// import _ from 'lodash'
import {
  READ_ISSUES,
  CREATE_ISSUE,
  UPDATE_ISSUES,
  DELETE_ISSUE,
  RESET_ISSUES,
} from "../actions";

const issues = (state = {}, action) => {
  switch (action.type) {
    case READ_ISSUES:
      // console.log("action: ", action.response.success.issues);
      return action.response.success;
    case CREATE_ISSUE:
      // console.log('action: ', action)
      return {
        ...state,
        issues: [action.data.issue, ...state.issues],
      };
    // case UPDATE_ISSUE:
    //   console.log('state: ', state)
    //   return state
    case DELETE_ISSUE:
      return state;
    case UPDATE_ISSUES:
      const update_issues = state.issues.map((issue) => {
        if (issue.id === action.res.id) {
          issue.status = {
            id: action.res.issue_status,
            name: action.res.status_name,
          };
        }
        return issue;
      });
      return {
        ...state,
        issues: update_issues,
      };
    case RESET_ISSUES:
      return [];
    default:
      return state;
  }
};

export default issues;
